import { z } from 'zod';
import { BaseValidations } from '@anytag/shared-validations';
import { DownloadFileType, UnionOfKeys } from '@anytag/shared-types';

export const ExportTagsSchema = BaseValidations.PeriodWithStartDateRequiredSchema.extend({
  type: z.nativeEnum(DownloadFileType)
});
export type ExportTagsFormValues = z.infer<typeof ExportTagsSchema>;
export type ExportTagsFormKeys = UnionOfKeys<ExportTagsFormValues>;
